export const GET_TEAMS = "GET_TEAMS"
export const GET_TEAMS_SUCCESS = "GET_TEAMS_SUCCESS"
export const GET_TEAMS_FAILURE = "GET_TEAMS_FAILURE"
export const DRAG_TEAM = "DRAG_TEAM"


// WEBPACK FOOTER //
// ./src/types/dragActionTypes.js